import SurveyFormStep from '@src/components/survey/SurveyFormStep';
import { surveyQuestions } from '@src/components/survey/surveyData';
import { filterLocaleNodesSubjects } from '@src/i18n/localeList';
import { setSurveyInfo } from '@src/services/auth';
import { useUser } from '@src/services/userContext';
import api from '@src/utils/api';
import { graphql, useStaticQuery } from 'gatsby';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Box } from 'theme-ui';
import './SurveyBox.scss';

type surveyAnswersT = {
  user_id?: number | null;
  user_type?: string;
  name?: string;
  discount_code?: string;
  subject?: string;
  grade?: number | string;
  topic?: string;
  phone_number?: string;
  email?: string;
  channel?: string;
};

type formProps = {
  setIsFormCompleted: (value: boolean) => void;
  surveyQuestion: number;
  setSurveyQuestion: (value: number) => void;
  setIsSurveyOpen: (value: boolean) => void;
};

function SurveyForm({
  setIsFormCompleted,
  surveyQuestion,
  setSurveyQuestion,
  setIsSurveyOpen,
}: formProps) {
  const { t, i18n } = useTranslation();
  const [countryCodeInput, setCountryCodeInput] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const user = useUser();

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    getValues,
    setValue,
  } = useForm({ mode: 'onChange' });
  const data = useStaticQuery(graphql`
    query {
      allContentfulMokomasisDalykas(sort: { name: ASC }) {
        nodes {
          ...SubjectsInfo
          navIcon: icon {
            gatsbyImageData(
              width: 60
              quality: 100
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }
    }
  `);
  useEffect(() => {
    let subjectsData = filterLocaleNodesSubjects(
      data.allContentfulMokomasisDalykas.nodes,
      i18n.language
    );
    subjectsData = subjectsData.filter((subject) => subject.uniqueId !== 13);
    surveyQuestions.find(
      (question) => question.question === 'subject'
    ).options = subjectsData;
    surveyQuestions;
  }, [data]);
  const sendPartialSurveyData = async () => {
    const currentValues = getValues();
    const partialSurveyData = {
      email: currentValues.email,
      name: currentValues.name,
      user_type: currentValues.user_type,
    };
    await api.post('public/surveyPartialResponse', partialSurveyData);
  };
  const submitSurvey = async (formData: surveyAnswersT) => {
    setErrorMessage('');
    formData.phone_number = countryCodeInput.getNumber(
      intlTelInputUtils.numberFormat.E164
    );
    if (user?.userToken) {
      formData.user_id = user.id;
    }
    try {
      const result = await api.post('public/surveyResponse', formData);
      if (result.success) {
        setIsFormCompleted(true);
        setSurveyInfo({ surveyCompleted: true });
      }
      if (result.errors) {
        setErrorMessage(t('survey.error'));
      }
    } catch (e) {
      console.log(e);
      setErrorMessage(t('survey.error'));
    }
  };
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
      }}
    >
      <form
        action=""
        onSubmit={handleSubmit(submitSurvey)}
        style={{ height: '100%' }}
      >
        {surveyQuestions?.map((question, questionIndex) => (
          <SurveyFormStep
            key={questionIndex}
            question={question}
            questionIndex={questionIndex}
            surveyQuestion={surveyQuestion}
            register={register}
            setSurveyQuestion={setSurveyQuestion}
            setIsSurveyOpen={setIsSurveyOpen}
            errors={errors}
            isValid={isValid}
            surveyQuestionsLength={surveyQuestions.length}
            getValues={getValues}
            setValue={setValue}
            countryCodeInput={countryCodeInput}
            setCountryCodeInput={setCountryCodeInput}
            sendPartialSurveyData={sendPartialSurveyData}
          />
        ))}
      </form>
    </Box>
  );
}

export default SurveyForm;
